import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';
import ClinicTable from './components/ToolsTable';
import ToolsPanel from './components/ToolForm';

const Tools = () => {
  const navigate = useNavigate();
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;

  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTools = async () => {
    setLoading(true);
    try {
      const response = await createAPIEndPoint('tools').fetchAll(); // Still fetching assistants
      setTools(response.data || []);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching tools');
      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTools();
  }, []);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      {/* <ClinicTable
        tableData={tools}
        loading={loading}
        fetchAgain={fetchClinics}
      /> */}
      <ToolsPanel tools={tools} fetchAgain={fetchTools} />
    </Box>
  );
};

export default Tools;
